import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { propTypes } from "react-bootstrap/esm/Image";
import { Link } from "react-router-dom";
import ActionButton from "../Common/ActionButton";
import { withRouter } from "react-router-dom";
// api
import { Signle_Call } from "../Api/Api";
import PulseLoader from "react-spinners/PulseLoader";
import { ExamTimeTypes, ExamTime } from "../../Functions";

const Itemcours = (props) => {
  const [reading, setReading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [errorExam, setErrorExam] = useState(false);

  useEffect(() => {
    props.read.map((isRead) => {
      if (!isRead) {
        setReading(false);
      }
    });
  }, [props.read]);

  const handle_getExamInfo = async () => {
    setLoader(true);
    const apiCall = () => {

      const apiCall = async (tools) => {
        const ApiCall = await Signle_Call(tools);
        return ApiCall;
      };
      return new Promise((result) => {
        result(
          apiCall({
            method: "get",
            data: false,
            path: `exam/${props.data.exam == null ? 0 : props.data.exam.id}`,

          })
        );
      });
    };
    const getExam_result = await apiCall();
    setLoader(false);
    if (
      getExam_result.type &&
      getExam_result.response.data.questions.length !== 0
    ) {
      getExam_result.response.data.exam_id = props.data.exam.id;
      localStorage.setItem(
        "examTimeLeft",
        ExamTime(ExamTimeTypes.encrypt, getExam_result.response.data.exam_time)
      );
      props.history.push("/exam", getExam_result.response.data);
    } else {
      setErrorExam(true);
    }
  };

  const handleTutorial = () => {
    props.history.push(`/education/mycourses/${props.id}`);
  };

  return (
    <div className="item-course">
      <div className="title-detail">
        <span>نام کرس:</span>
        <h4>{props.title}</h4>
      </div>
      <div className="row-details">
        <span>
          <b>امتیاز این کرس : </b>
          <i className="icon-black-star-silhouette"></i>
          {props.score}
        </span>
        <div className="btns">
          <div
            className={`btn-base btn-transparent ${
              props.has_tutorial ? "active btn-black" : ""
            }`}
          >
            <Button
              variant="contained"
              onClick={(e) =>
                props.has_tutorial ? handleTutorial() : e.preventDefault()
              }
            >
              {props.has_tutorial ? "✓ " : ""}
              آموزش
            </Button>
          </div>
          <div
            className={`btn-base btn-transparent ${
              reading && props.has_exam ? "active btn-black" : ""
            }`}
          >
            {loader ? (
              <Button variant="contained">
                <PulseLoader color="#fff" loading={true} size={10} />
              </Button>
            ) : (
              <Button
                variant="contained"
                onClick={(e) =>
                  reading && props.has_tutorial
                    ? handle_getExamInfo()
                    : e.preventDefault()
                }
              >
                {props.has_exam ? "✓ " : ""}
                آزمون
              </Button>
            )}
          </div>
        </div>
      </div>
      {errorExam ? (
        <span className="error-qustion">
          مشکلی بوجود آمده لطفا دوباره تلاش کنید
        </span>
      ) : null}
    </div>
  );
};

export default withRouter(Itemcours);
